export default "__VITE_ASSET__BJwoC2Jx__"